import { FaCaretDown } from "react-icons/fa";
import { PiCaretDown } from "react-icons/pi";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";

const SimpleDropdownInput2 = ({
  value,
  setValue,
  placeholder,
  options,
  renderOption,
  dropdownClass,
  renderValue,
}) => {
  return (
    <UncontrolledDropdown className="icon-input-2">
      <DropdownToggle className="p-0 border-none bg-transparent full-width color-primary-black-2">
        <div className="px-2 py-3 d-flex align-items-center justify-content-between">
          <p className="m-0">
            {typeof value === "object" && renderValue
              ? renderValue(value)
              : typeof value === "object"
              ? value?.title
              : value}
          </p>
          <div>
            <PiCaretDown size={20} />
          </div>
        </div>
      </DropdownToggle>
      <DropdownMenu
        className={`full-width  outer-transparent-shadow ${dropdownClass}`}
      >
        {options?.map((item, key) => (
          <DropdownItem onClick={() => setValue(item)} key={key}>
            {typeof item === "object" && renderOption
              ? renderOption(item)
              : typeof item === "object"
              ? item?.title
              : item}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default SimpleDropdownInput2;
